import { FlagProblem } from 'types';

export function buildFlagProblems(options: { label: string; value: string }[], criterionId: string): FlagProblem[] {
  const problems: FlagProblem[] = [];

  for (const option of options) {
    // Support embedded criterion prefix: "criterionId::rawValue"
    const sepIndex = option.value.indexOf('::');
    const effectiveCriterionId = sepIndex !== -1 ? option.value.slice(0, sepIndex) : criterionId;
    const rawValue = sepIndex !== -1 ? option.value.slice(sepIndex + 2) : option.value;

    const dashIndex = rawValue.indexOf('-');
    if (dashIndex !== -1) {
      const problemId = rawValue.slice(0, dashIndex);
      const detail = rawValue.slice(dashIndex + 1);
      const displayText = option.label.split(' - ')[0];
      const existing = problems.find((p) => p.id === problemId);
      if (existing) {
        existing.details = [...(existing.details ?? []), detail];
      } else {
        problems.push({ id: problemId, displayText, details: [detail], acceptanceCriteriaId: effectiveCriterionId });
      }
    } else {
      problems.push({ id: rawValue, displayText: option.label, acceptanceCriteriaId: effectiveCriterionId });
    }
  }

  return problems;
}
